// Infinite scroll — uses IntersectionObserver on the loader element.
// Once the loader scrolls into view we fire haegoziya_load_more (admin-ajax).
// Renders the returned HTML into the grid and increments the page counter.

import { getAjaxUrl } from './_ajax.js';

function setup(grid) {
    if (!grid) return;
    if (grid.dataset.infiniteInit) return;
    grid.dataset.infiniteInit = '1';

    const loader = document.querySelector('[data-infinite-loader]');
    if (!loader) return;

    const source = grid.getAttribute('data-infinite-source') || 'archive';
    let page     = parseInt(grid.getAttribute('data-infinite-current') || '1', 10);
    const maxPage = parseInt(grid.getAttribute('data-infinite-max-page') || '999', 10);
    const termId = parseInt(grid.getAttribute('data-infinite-term-id') || '0', 10);
    const tax    = grid.getAttribute('data-infinite-taxonomy') || '';
    let loading  = false;
    let done     = false;

    async function loadMore() {
        if (loading || done) return;
        if (page >= maxPage) { done = true; loader.classList.add('is-done'); return; }
        loading = true;

        try {
            const fd = new FormData();
            fd.append('action',   'haegoziya_load_more');
            fd.append('source',   source);
            fd.append('page',     page + 1);
            fd.append('term_id',  termId);
            fd.append('taxonomy', tax);
            const res = await fetch(getAjaxUrl(), { method: 'POST', body: fd, credentials: 'same-origin' });
            const json = await res.json();
            if (json && json.success && json.data.html) {
                const tpl = document.createElement('template');
                tpl.innerHTML = json.data.html.trim();
                grid.appendChild(tpl.content);
                page++;
                document.dispatchEvent(new Event('haegoziya:wishlist-changed'));
                if (!json.data.has_more) { done = true; loader.classList.add('is-done'); }
            } else {
                done = true; loader.classList.add('is-done');
            }
        } catch (e) {
            done = true; loader.classList.add('is-done');
        } finally {
            loading = false;
        }
    }

    const io = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.isIntersecting) loadMore();
    }, { rootMargin: '300px 0px' });
    io.observe(loader);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-infinite-grid]').forEach(setup);
});
